exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".telemedicine-container {\n  font-size: 20px;\n  line-height: 20px;\n  font-family: 'Arsenal-Bold';\n  min-height: 650px; }\n  .telemedicine-container .telemedicine-container__photo img {\n    width: 100%; }\n  .telemedicine-container .telemedicine-container__description {\n    font-size: 16px;\n    padding-bottom: 20%;\n    margin: 12px;\n    color: #23275E;\n    font-weight: 400;\n    font-family: 'Arsenal-Regular'; }\n    .telemedicine-container .telemedicine-container__description .telemedicine-container__description__content {\n      margin-bottom: 12px; }\n    .telemedicine-container .telemedicine-container__description pre {\n      font-family: 'Arsenal-Regular'; }\n    .telemedicine-container .telemedicine-container__description div {\n      margin-bottom: 18px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Telemedicine/Home/HomeView.scss
// module id = 315
// module chunks = 0